import styled from '@emotion/styled';

export const CollectionRulesListStyled = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 10px;
`;
